<template>
  <v-autocomplete
      :items="items"
      item-value="id"
      item-text="title"
      no-data-text="Žiadne výsledky"
      :loading="loading"
      :disabled="loading"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <template
        v-slot:append-outer
    >
      <CreateRegion
          v-if="createButton"
          :icon="true"
          :small="true"
          @init="init"
      />

      &nbsp;

      <v-btn
          :small="true"
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
  import Regions from '@/services/regions'

  import CreateRegion from '@/components/Regions/Create'

  export default {
    name: 'Suggest',
    props: [
      'support',
      'createButton'
    ],
    components: {
      CreateRegion
    },
    data() {
      return {
        loading: false,
        regions: []
      }
    },
    mounted() {
      this.init()
    },
    computed: {
      items() {
        return (
          typeof this.support === 'function'
            ? this.support(this.regions)
            : this.regions
        )
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      loadData() {
        this.loading = true

        Regions
          .suggest()
          .then((response) => {
            this.regions = response.data.data.regions
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
